/**
 * SizeSelector - Grid of size options for menu items
 */
import { memo } from 'react';

const SizeSelector = memo(function SizeSelector({ 
  sizes = [], 
  selectedSize, 
  onSelectSize,
  stepNumber = 1 
}) {
  if (sizes.length === 0) return null;

  return (
    <div>
      <h4 className="font-medium text-base mb-2 flex items-center gap-2">
        <span className="w-5 h-5 rounded-full bg-primary/10 flex items-center justify-center text-xs text-primary font-bold">
          {stepNumber}
        </span>
        Select Size
      </h4>
      <div className="grid grid-cols-2 gap-2">
        {sizes.map(size => (
          <button
            key={size.name}
            onClick={() => onSelectSize(size.name)}
            data-testid={`size-${size.name.toLowerCase()}`}
            className={`p-3 rounded-xl border-2 transition-all flex justify-between items-center ${
              selectedSize === size.name
                ? 'border-primary bg-primary/10'
                : 'border-border bg-card hover:border-primary/50'
            }`}
          >
            <span className="font-medium text-sm">{size.name}</span>
            <span className="text-primary font-medium text-sm">${size.price.toFixed(2)}</span>
          </button>
        ))}
      </div>
    </div>
  );
});

export default SizeSelector;
